

    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop } from "vue-property-decorator";

    @Component({ })
    export default class PrintCheckbox extends Vue {

        @Prop({ default: false }) value!: boolean;

        @Prop({ default: "" }) label!: string;

        @Prop({ default: false }) isBoldLabel!: boolean;

        @Prop({ default: false }) isRightAlign!: boolean;

        @Prop({ default: false }) isInline!: boolean;

        @Prop({ default: false }) disabled!: boolean;

        tickedImageUrl = require("@/images/print-check-box-ticked.svg");
        tickedDisabledImageUrl = require("@/images/print-check-box-ticked-disabled.svg");
        untickedImageUrl = require("@/images/print-check-box-un-ticked.svg");
        untickedDisabledImageUrl = require("@/images/print-check-box-un-ticked-disabled.svg");
        untickedPrintImageUrl = require("@/images/print-check-box-un-ticked-print.svg");

        onClick() {
            if(this.disabled) return;
            this.$emit("input", !this.value);
        }
    }
